import { icon } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'fileUpload',
  label: 'File Upload',
  category: 'Data Display',
  image: icon,
};
